import { FC } from "react";
import { Box } from "@smile2impress/components";

import { Typeform } from "components/Typeform";
import { TypeformCPH } from "components/Typeform/constants";

export const QuestionnaireCphLayout: FC = () => {
    return (
        <Box h="100svh">
            <Typeform typeformIds={TypeformCPH} />
        </Box>
    );
};
